import { FeaturedImageFragment } from '@/fragments/FeaturedImage'
import { FlexibleContentFragment } from '@/fragments/FlexibleContent'
import { GravityFormsFragment } from '@/fragments/GravityForms'
import { LeaderCardFieldsFragment } from '@/fragments/Leaders'
import { PostsFragment } from '@/fragments/Posts'
import { gql } from '@apollo/client'

export const variables = ({ databaseId }, ctx) => {
  return {
    databaseId,
    asPreview: ctx?.asPreview
  }
}

export const query = gql`
  ${FeaturedImageFragment}
  ${FlexibleContentFragment}
  ${GravityFormsFragment}
  ${LeaderCardFieldsFragment}
  ${PostsFragment}
  query GetLeadershipPageData($databaseId: ID!, $asPreview: Boolean = false) {
    page(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      title
      seo {
        metaDesc
        title
      }
      ...FeaturedImageFragment
      ...FlexibleContentFragment
      innerHeroFields {
        content
        eyebrowText
        fieldGroupName
        includeForm
        title
      }
      # Ordered explicitly: the connection does not sort by menuOrder on its own, and the
      # grid reads both the row (tens digit) and the position within it from that value.
      children(first: 50, where: { orderby: { field: MENU_ORDER, order: ASC } }) {
        nodes {
          ...LeaderCardFields
        }
      }
    }
    posts(first: 12) {
      nodes {
        ...PostsFeedItemFragment
      }
    }
    contactForm: gfForm(id: 1, idType: DATABASE_ID) {
      ...GravityFormsFragment
    }
    headerForm: gfForm(id: 2, idType: DATABASE_ID) {
      ...GravityFormsFragment
    }
  }
`
